import { render, staticRenderFns } from "./Fa.vue?vue&type=template&id=0ca1235e&scoped=true&"
import script from "./Fa.vue?vue&type=script&lang=js&"
export * from "./Fa.vue?vue&type=script&lang=js&"
import style0 from "./Fa.vue?vue&type=style&index=0&id=0ca1235e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca1235e",
  null
  
)

export default component.exports